var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeOrderCreated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 48,
    viewBox: "0 0 215 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.85352 32.4367C1.85352 32.4367 10.184 31.3611 19.6552 33.9451C37.6689 38.8596 38.6966 29.8599 45.3763 25.5204C51.4874 21.5503 56.5486 23.9726 63.353 28.8278C68.3715 32.4087 75.6853 38.4196 83.2595 37.4519C90.1832 36.5673 95.0915 29.5174 104.688 27.7245C112.295 26.3035 118.476 30.2073 127.234 28.8278C139.116 26.9563 144.423 15.9388 152.915 15.9388C163.396 15.9388 170.775 6.62061 180.31 6.62061C189.788 6.62061 191.075 12.0999 201.443 15.9388C209.369 18.8737 213.183 15.9388 213.183 15.9388V47.3879H1.85352V32.4367Z",
    fill: "url(#paint0_linear_8655_9942)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85352 27.552C1.85352 27.552 10.184 26.492 19.6552 29.0385C37.6689 33.8819 38.6966 25.0125 45.3763 20.7359C51.4874 16.8232 56.5486 19.2104 63.353 23.9953C68.3715 27.5244 75.6853 33.4483 83.2595 32.4946C90.1832 31.6229 95.0915 24.6749 104.688 22.908C112.295 21.5075 118.476 25.3549 127.234 23.9953C139.116 22.151 144.423 11.2929 152.915 11.2929C163.396 11.2929 170.775 2.0874 180.31 2.0874C189.788 2.0874 190.292 7.50962 200.66 11.2929C208.587 14.1853 213.183 11.2929 213.183 11.2929",
    stroke: "#16CB79",
    strokeWidth: 2.71268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8655_9942",
    x1: 40.0463,
    y1: 27.3061,
    x2: 40.0463,
    y2: 47.3879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16CB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOrderCreated);
export default __webpack_public_path__ + "static/media/home-order-created.c2d3d8cd599875ea0b04caa24e4fee5e.svg";
export { ForwardRef as ReactComponent };